"use client";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { memo, useState } from "react";
import { useIntl } from "react-intl";

import { truncate } from "../../../shared/lib/truncate/truncate";

interface ShowOverviewProps {
  readonly overview: string;
}

export const ShowOverview = memo(({ overview }: ShowOverviewProps) => {
  const [showMore, setShowMore] = useState(false);
  const { formatMessage } = useIntl();

  const previewLength = 280;

  return (
    <Typography variant="body1">
      {showMore && (
        <>
          {overview}
          <Button variant="text" onClick={() => setShowMore(false)}>
            {formatMessage({ id: "show_overview_show_less" })}
          </Button>
        </>
      )}
      {!showMore && (
        <>
          {truncate(overview, previewLength)}
          {overview.length > previewLength && (
            <Button variant="text" onClick={() => setShowMore(true)}>
              {formatMessage({ id: "show_overview_show_more" })}
            </Button>
          )}
        </>
      )}
    </Typography>
  );
});
